module.exports = __webpack_public_path__ + "img/cedric_van_bockhaven.06b27429.jpg";